import { Typography } from '@mui/material';

type SigningStatusProps = {
  signatories?: Array<{ isComplete: boolean; isWitness: boolean }>;
  signatoriesRequired?: number;
};

const SigningStatus: React.FC<SigningStatusProps> = ({
  signatories,
  signatoriesRequired,
}) => {
  if (!signatories?.length) {
    return null;
  }

  const hasWitnesses = signatories.some((signatory) => signatory.isWitness);

  const total = signatoriesRequired
    ? Math.min(
        signatories.length,
        hasWitnesses ? signatoriesRequired * 2 : signatoriesRequired,
      )
    : signatories.length;
  const completed = signatories.filter(
    (signatory) => signatory.isComplete,
  ).length;
  const progressDetail = `(${completed}/${total})`;

  return (
    <Typography variant="body2">
      {completed === total
        ? `Signed ${progressDetail}`
        : `Awaiting signing ${progressDetail}`}
    </Typography>
  );
};

export default SigningStatus;
